import tickImage from "../assets/images/double-tick.png";
import noteImage from "../assets/images/notes.png";
import plusImage from "../assets/images/plus.png";
import {
    useChangeTodoStatusMutation,
    useGetTodosQuery,
} from "../Redux/features/api/apiSlice";

export default function Header({ submitHandler, newTodo, setNewTodo }) {
    const [changeTodoStatus] = useChangeTodoStatusMutation();
    const { data: todos } = useGetTodosQuery("All");

    const completeHadler = () => {
        todos.forEach((todo) => {
            changeTodoStatus({
                id: todo.id,
                status: true,
            });
            console.log(todo.id);
        });
    };

    const cleadTodosHandler = () => {
        todos.forEach((todo) => {
            changeTodoStatus({
                id: todo.id,
                status: false,
            });
        });
    };

    return (
        <div>
            <form
                className="flex items-center bg-gray-100 px-4 py-4 rounded-md"
                onSubmit={submitHandler}
            >
                <img src={noteImage} className="w-6 h-6" alt="Add todo" />
                <input
                    type="text"
                    placeholder="Type your todo"
                    className="w-full text-lg px-4 py-1 border-none outline-none bg-gray-100 text-gray-500"
                    value={newTodo}
                    onChange={(e) => setNewTodo(e.target.value)}
                />
                <button
                    type="submit"
                    className={`appearance-none w-8 h-8 bg-[url('${plusImage}')] bg-no-repeat bg-contain`}
                ></button>
            </form>

            <ul className="flex justify-between my-4 text-xs text-gray-500">
                <li
                    className="flex space-x-1 cursor-pointer"
                    onClick={completeHadler}
                >
                    <img className="w-4 h-4" src={tickImage} alt="Complete" />
                    <span>Complete All Tasks</span>
                </li>
                <li className="cursor-pointer" onClick={cleadTodosHandler}>
                    Clear completed
                </li>
            </ul>
        </div>
    );
}
